import IndexDetailCommunity from "../components/Community/[id]";

export default function ComunityView() {
  return (
    <>
      <IndexDetailCommunity />
    </>
  );
}
